export const BRAND = {
  name: "NEXA WASH",
  fullName: "NEXA WASH STUDIO",
  tagline: "Lavaggio Auto Nanotech Waterless",
  email: "nexawashstudio@gmail.com",
  phone: "+39 346 378 5564",
  phoneDisplay: "346 378 5564",
  whatsapp: "393463785564",
  whatsappMsg: "Ciao NexaWash, vorrei un preventivo per il lavaggio della mia auto.",
  address: "Via Curio Dentato, 9 - Rieti",
  addressLong: "Via Curio Dentato, 9 — 02100 Rieti (RI)",
  piva: "01263280578",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Via+Curio+Dentato+9+Rieti",
  domain: "washnexastudio.com",
};

export const IMAGES = {
  gazebo: "https://customer-assets.emergentagent.com/job_928eee40-3e00-4925-a271-6b1b009651d8/artifacts/stgwqnd4_image.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/928eee40-3e00-4925-a271-6b1b009651d8/images/57c92c93fc9d9028272b6dc6a6649df3a4e7055576c671fa1c60662c189ef724.png",
  beads: "https://static.prod-images.emergentagent.com/jobs/928eee40-3e00-4925-a271-6b1b009651d8/images/92bffdd6a77a4bd4be2833c7e3c7d530436b2bdfa121311e4f101e78ee236fae.png",
  gallery: [
    "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmclMjBwb2xpc2hpbmd8ZW58MHx8fHwxNzc2NTA4OTYwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1739161763846-2640e24df6f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMGJsYWNrJTIwc3BvcnRzJTIwY2FyJTIwc3R1ZGlvfGVufDB8fHx8MTc3NjUwODk2MHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1739161763781-32314fdc8249?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGJsYWNrJTIwc3BvcnRzJTIwY2FyJTIwc3R1ZGlvfGVufDB8fHx8MTc3NjUwODk2MHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1761934657948-708146148588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxtaWNyb2ZpYmVyJTIwY2FyJTIwd2lwZXxlbnwwfHx8fDE3NzY1MDg5NzV8MA&ixlib=rb-4.1.0&q=85",
  ],
};

export const NAV_LINKS = [
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "servizi", label: "Servizi" },
  { id: "vantaggi", label: "Vantaggi" },
  { id: "come-funziona", label: "Come Funziona" },
  { id: "galleria", label: "Galleria" },
  { id: "faq", label: "FAQ" },
  { id: "preventivo", label: "Preventivo" },
  { id: "lavora-con-noi", label: "Lavora con Noi", type: "page", path: "/lavora-con-noi" },
];
